import React from "react";
import { Entity, Commitment } from "@ifgengineering/client-invest-sdk";
import { EntityBadge } from "@components/EntityBadge/EntityBadge.component";
import { AccountTabsContainer } from "./styled";

interface EisFundAccountTabsProps {
  commitments: Commitment[];
  selectedCommitmentId?: string;
  onCommitmentChange?: (commitmentId: string) => void;
}

const EisFundAccountTabs: React.FC<EisFundAccountTabsProps> = ({
  commitments,
  selectedCommitmentId,
  onCommitmentChange,
}) => {
  if (commitments.length <= 1) {
    return null;
  }

  return (
    <AccountTabsContainer>
      {commitments.map((commitment) => {
        const entity = commitment?.entity ? commitment.entity : null;
        const isIfIsa = !!commitment?.ifIsaAccountId;
        const isActive = selectedCommitmentId === commitment.id;

        return (
          <EntityBadge
            key={commitment.id}
            isIfIsa={isIfIsa}
            entity={entity as Entity}
            hideInfo={true}
            useAsActionButton={true}
            displayNameConfig={{ hide: true }}
            onClick={() => onCommitmentChange?.(commitment.id)}
            iconConfig={{
              showLabel: true,
              labelSize: "S16",
              showBorder: true,
              isActive,
            }}
          />
        );
      })}
    </AccountTabsContainer>
  );
};

export default EisFundAccountTabs;
